// 3rd party imports
import * as React from 'react';
import * as fetch from 'isomorphic-fetch';

//bernie
import { ContextStore, ExperimentStore, PageStore } from 'bernie-core';
import { ViewLarge, Viewport, ViewSmall } from 'bernie-view';

// uitk
import { ESSAdapter, TypeaheadSelection, UitkTypeahead } from 'uitk-react-typeahead';
import { UitkPrimaryButton } from 'uitk-react-button';
import { UitkTextArea, UitkTextInput } from 'uitk-react-input';
import { UitkHeading, UitkText } from 'uitk-react-text';
import { UitkToast } from 'uitk-react-toast';
import { UitkSelect } from 'uitk-react-select';
import { UitkCheckbox, UitkToggleSwitch } from 'uitk-react-switch';
import { UitkButtonToggle } from 'uitk-react-button-toggle';
import { UitkLayoutGridItem, UitkLayoutGrid } from 'uitk-react-layout-grid';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkSpacing, UitkSpacingHr } from 'uitk-react-spacing';

//utils
import { hasValidDateRange, isValidDateFormat } from '../../../../util/DatesUtil';

// components
import Loader from '../../common/loader';
import { RoomComponentPackage as RoomComponent } from './room-component-package';
import { PackageChildComponent as ChildComponent } from './package-child-component';
import { TypeaheadSelectionPropsHIS } from '../hotels/hotel-details';

export interface PackageExampleProps {
  // example: ExampleStore;
  context: ContextStore;
  logger?: Logger;
  page?: PageStore;
  experiment?: ExperimentStore;
  startDate?: Date;
  endDate?: Date;
}

export interface PackageExampleState {
  date: string;
  flightInfo: any;
  isHydrated: boolean;
  openVal: boolean;
}

export interface TypeaheadSourceSelectionProps {
  data: PackageTypeaheadDataProps;
  term: string;
}

export interface TypeaheadDestinationSelectionProps {
  data: PackageTypeaheadDataProps;
  term: string;
}

interface HierarchyInfo {
  airport: Airport;
}

interface Airport {
  airportCode: string;
  airportId: string;
  metrocode: string;
  multicity: string;
}

export interface PackageTypeaheadDataProps {
  regionId: string;
  originId: string;
  hierarchyInfo: HierarchyInfo;
  selectedSourceLocation: string;
  selectedDestinationLocation: string;
}

export class PackageLobSearch extends React.Component<any, any> {
  public onCloseRef;

  public constructor(props) {
    super(props);
    this.state = { value: props.value };
    this.handleClick = this.handleClick.bind(this);
    this.handleUrlOpen = this.handleUrlOpen.bind(this);
    this.onChildAgeChange = this.onChildAgeChange.bind(this);
    this.onAdultCountChange = this.onAdultCountChange.bind(this);
    this.onAirlineChange = this.onAirlineChange.bind(this);
    this.onChildCountChange = this.onChildCountChange.bind(this);
    this.onDestinationLocationChange = this.onDestinationLocationChange.bind(this);
    this.onSourceLocationChange = this.onSourceLocationChange.bind(this);
    this.onFlightClassChange = this.onFlightClassChange.bind(this);
    this.onFlightDirects = this.onFlightDirects.bind(this);
    this.onFlightPenalty = this.onFlightPenalty.bind(this);
    this.onInfantCountChange = this.onInfantCountChange.bind(this);
    this.onSeniorCountChange = this.onSeniorCountChange.bind(this);
    this.copyToClipBoard = this.copyToClipBoard.bind(this);
    this.handlePin = this.handlePin.bind(this);
    this.handleHotelId = this.handleHotelId.bind(this);
    this.onAgeChange = this.onAgeChange.bind(this);
    this.handleSortChange = this.handleSortChange.bind(this);
    this.state = {
      startDate: '',
      endDate: '',
      isLoading: false,
      copyMessage: "Sorry! you don't have a deeplink to copy",
      triptype: 'roundtrip',
      preferredairline: 'N/A',
      flightclasschange: 'e',
      flightdirectchange: '0',
      flightpenaltychange: '0',
      openVal: false,
      starRating: [],
      roomStateChange: false,
      roomCount: 1,
      roomComponents: [],
      sort: 0,
      numAdults: { adultCount1: 1, adultCount2: 1, adultCount3: 1, adultCount4: 1, adultCount5: 1, adultCount6: 1 },
      numInfants: {
        infantCount1: 0,
        infantCount2: 0,
        infantCount3: 0,
        infantCount4: 0,
        infantCount5: 0,
        infantCount6: 0,
      },
      numChild: { childCount1: 0, childCount2: 0, childCount3: 0, childCount4: 0, childCount5: 0, childCount6: 0 },
      childDetails: { child1: [], child2: [], child3: [], child4: [], child5: [], child6: [] },
      childAge1: [-1, -1, -1, -1, -1, -1],
      childAge2: [-1, -1, -1, -1, -1, -1],
      childAge3: [-1, -1, -1, -1, -1, -1],
      childAge4: [-1, -1, -1, -1, -1, -1],
      childAge5: [-1, -1, -1, -1, -1, -1],
      childAge6: [-1, -1, -1, -1, -1, -1],
      childAge7: [-1, -1, -1, -1, -1, -1],
      childAge8: [-1, -1, -1, -1, -1, -1],
      childStatus: false,
      childCount: 0,
      errors: { location: '', dates: '' },
      error: false,
      message: '',
      copyStatus: false,
      pinHotel: false,
      hotelId: '',
      allAmenity: false,
      air_condition: false,
      pool: false,
      speed: false,
      parking: false,
      pets: false,
      free_transport: false,
      breakfast: false,
      kitchen: false,
      travelerCount: '',
      regionId: '',
    };
  }

  public handleDatesChange = (event) => {
    const errors1 = this.state.errors;
    errors1['dates'] = '';
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  };

  public validateDates(name: string) {
    const { startDate, endDate } = this.state;
    if ((!startDate && name === 'startDate') || (!endDate && name === 'endDate')) {
      return;
    }

    if (name === 'startDate' && !isValidDateFormat(startDate)) {
      return 'Please enter valid From date in the format mm/dd/yyyy';
    }
    if (name === 'endDate' && !isValidDateFormat(endDate)) {
      return 'Please enter valid To date in the format mm/dd/yyyy';
    }
  }

  public handlePin(event) {
    this.setState({
      pinHotel: event.currentTarget.checked,
    });
  }

  public onChildAgeChange(event) {
    const { value } = event.target;
    const childAgeArray = this.state.childAges;
    const key = event.target.id;
    childAgeArray[key] = value;
    this.setState({
      childAges: childAgeArray,
    });
  }

  public handleHotelId = (selection: TypeaheadSelection) => {
    const errors1 = this.state.errors;
    errors1['hotelId'] = '';
    this.setState({
      errors: errors1,
      message: '',
    });
    const { data, term } = selection as TypeaheadSelectionPropsHIS;
    this.setState({ hotelId: data['selected'] });
  };

  public renderStarRating = () => {
    const starElements = [];
    for (let i = 1; i <= 5; i++) {
      starElements.push(
        <div key={i} className="uitk-cell">
          <UitkCheckbox id={`${i}-star`} label={`${i} Star`} onChange={this.handleStarRating} />
        </div>,
      );
    }

    return starElements;
  };

  public renderAmenities = () => {
    const amenityCode = ['air_condition', 'pool', 'speed', 'parking', 'pets', 'free_transport', 'breakfast', 'kitchen'];
    const amenities = {
      air_condition: 'Air condition',
      pool: 'Swimming pool',
      speed: 'High-speed Internet',
      parking: 'Free parking',
      pets: 'Pets allowed',
      free_transport: 'Free airport shuttle',
      breakfast: 'Free breakfast',
      kitchen: 'Kitchen',
    };
    const amenityElements = [];
    let aCode = '';
    let amenity = '';
    for (let i = 0; i < amenityCode.length; i++) {
      aCode = amenityCode[i];
      amenity = amenities[aCode];
      amenityElements.push(
        <UitkLayoutFlexItem key={i}>
          <UitkButtonToggle labelText={amenity} id={aCode} checked={this.state[aCode]} onChange={this.handleAmenity} />
        </UitkLayoutFlexItem>,
      );
    }

    return amenityElements;
  };

  public handleStarRating = (event) => {
    const starRating1 = [...this.state.starRating];
    if (starRating1.includes(event.currentTarget.id)) {
      if (!event.currentTarget.checked) {
        const index = starRating1.indexOf(event.currentTarget.id);
        starRating1.splice(index, 1);
      }
    } else {
      if (event.currentTarget.checked) {
        starRating1.push(event.currentTarget.id);
      }
    }
    this.setState({
      starRating: starRating1,
    });
  };

  public handleSortChange = (event) => {
    const value = event.currentTarget.value;
    this.setState({
      sort: value,
    });
  };

  public renderRoom() {
    const temp = this.state.roomCount;

    const rooms = [];

    for (let i = 1; i < temp; i++) {
      rooms.push(
        <RoomComponent
          onAdultCountChange={this.onAdultCountChange}
          onChildCountChange={this.onChildCountChange}
          onInfantCountChange={this.onInfantCountChange}
          roomCount={i + 1}
          childComponent={this.state[`childComponent${i + 1}`]}
        />,
      );
    }

    this.setState({
      roomComponents: rooms,
      roomStateChange: true,
    });
    /*const rooms = [];
    for(let i=0;i<this.state.roomCount-1;i++) {
      rooms.push(this.state.roomComponents[i]);
    }
    this.setState({
      roomComponents: rooms,
      roomStateChange: true
    })*/
  }

  public onAgeChange(event) {
    const { value } = event.target;
    const childId = event.currentTarget.getAttribute('id');
    const idChar = childId.substring(9, childId.length);
    const roomNo = idChar.split('-')[0];
    const childNum = idChar.split('-')[1];
    const totalChild = idChar.split('-')[2];
    const childAge = this.state[`childAge${roomNo}`];
    childAge[childNum - 1] = value;
    this.setState({
      [`childAge${roomNo}`]: childAge,
    });
  }

  public handleAmenity = (event) => {
    if (!event.currentTarget.checked) {
      this.setState({
        allAmenity: false,
      });
    }
    if (event.currentTarget.id === 'all_amenity') {
      this.setState({
        allAmenity: event.currentTarget.checked,
        air_condition: event.currentTarget.checked,
        pool: event.currentTarget.checked,
        speed: event.currentTarget.checked,
        parking: event.currentTarget.checked,
        pets: event.currentTarget.checked,
        free_transport: event.currentTarget.checked,
        breakfast: event.currentTarget.checked,
        kitchen: event.currentTarget.checked,
      });
    }
    this.setState({
      [event.currentTarget.id]: event.currentTarget.checked,
    });
  };

  public onChildCountChange = (event) => {
    this.setState({
      roomStateChange: false,
    });
    const { value } = event.target;
    const childArray = [];
    const roomId = event.currentTarget.getAttribute('id');
    const roomNum = roomId.substring(11, roomId.length);
    const childAge = this.state[`childAge${roomNum}`];
    for (let i = 0; i < Number(value); i++) {
      childAge[i] = 2;
    }
    for (let i = Number(value); i < 4; i++) {
      childAge[i] = -1;
    }
    this.setState({
      childCount: value,
    });
    this.setState({
      [`childAge${roomNum}`]: childAge,
    });
    for (let i = 1; i <= value; i++) {
      childArray.push(
        <ChildComponent roomCount={roomNum} childCount={i} totalChild={value} onAgeChange={this.onAgeChange} />,
      );
    }
    this.setState(
      {
        [`childComponent${roomNum}`]: childArray,
      },
      () => this.renderRoom(),
    );

    const rooms = [];

    const childArray1 = this.state.numChild;
    const temp = this.state.roomCount;
    const childId = event.currentTarget.getAttribute('id');
    const childrenArray = this.state.numChild;
    const childId1 = 'childCount' + childId.substring(11, childId.length);
    childrenArray[childId1] = Number(value);
    this.setState({
      numChild: childrenArray,
    });

    for (let i = 1; i < temp; i++) {
      rooms.push(
        <RoomComponent
          onAdultCountChange={this.onAdultCountChange}
          onChildCountChange={this.onChildCountChange}
          onInfantCountChange={this.onInfantCountChange}
          roomCount={i + 1}
          childComponent={this.state[`childComponent${i + 1}`]}
        />,
      );
    }

    this.setState(
      {
        roomComponents: rooms,
        roomStateChange: true,
      },
      () => this.renderRoom(),
    );
  };

  public renderSort() {
    const sort = [
      { key: '0', value: 'Featured' },
      { key: '10', value: 'Price' },
      { key: '4', value: 'Distance from Downtown' },
      { key: '12', value: 'Guest Rating' },
      { key: '34', value: 'Vacation Rentals' },
      { key: '14', value: 'Package Discount' },
      { key: '27', value: 'Best Deals' },
    ];

    return sort.map((opts) => {
      return (
        <option key={opts.key} value={opts.key}>
          {opts.value}
        </option>
      );
    });
  }

  public fetchData() {
    // tslint:disable-next-line:no-console
    const trip = this.state.triptype;
    const preferredAirline = this.state.preferredairline;
    const flightClassChange = this.state.flightclasschange;
    const flightDirectChange = this.state.flightdirectchange;
    const flightPenaltyChange = this.state.flightpenaltychange;
    const numSenior = this.state.seniorCount;
    const numinfants = this.state.infantCount;
    const source = this.state.selectedSourceLocation;
    const destination = this.state.selectedDestinationLocation;
    const mainCategory = 'package';
    const subCategory = 'flightHotel';
    const numAdult = this.state.adultCount;
    const numchild = this.state.numChild;
    const childage = this.state.childId;
    const checkInDate = this.state.startDate;
    let checkOutDate = this.state.endDate;
    if (checkOutDate === undefined || checkOutDate === '') {
      checkOutDate = checkInDate;
    }
    const formattedStarRating = [];
    const formattedStars = [];
    let starString = '';
    const starRatings = this.state.starRating;
    let formattedStarRatingString = '';
    if (starRatings !== [] && starRatings !== undefined && starRatings !== null) {
      starRatings.forEach((item) => {
        switch (item) {
          case '1-star':
            formattedStarRating.push('hotelClass=10');
            formattedStars.push('10');
            break;
          case '2-star':
            formattedStarRating.push('hotelClass=20');
            formattedStars.push('20');
            break;
          case '3-star':
            formattedStarRating.push('hotelClass=30');
            formattedStars.push('30');
            break;
          case '4-star':
            formattedStarRating.push('hotelClass=40');
            formattedStars.push('40');
            break;
          case '5-star':
            formattedStarRating.push('hotelClass=50');
            formattedStars.push('50');
            break;
        }
      });

      formattedStarRatingString = '';
      for (let i = 0; i < formattedStarRating.length; i++) {
        if (i === 0) {
          formattedStarRatingString = formattedStarRating[i];
          starString = `flightHotel-HotelClass=${formattedStars[i]}`;
        } else {
          formattedStarRatingString = formattedStarRatingString + `&${formattedStarRating[i]}`;
          starString = starString + `,${formattedStars[i]}`;
        }
      }
    }
    let param =
      `main-category=${mainCategory}&sub-category=${subCategory}` +
      `&flightHotel-TripType=${trip}` +
      `&flightHotel-FromAirport=${source}` +
      `&flightHotel-Destination=${destination}` +
      `&flightHotel-FromDate=${checkInDate}&flightHotel-ToDate=${checkOutDate}&flightHotel-SearchType=Destination` +
      `&flightHotel-cabinClass=${flightClassChange}` +
      `&flightHotel-Direct=${flightDirectChange}&flightHotel-NoChangePenalty=${flightPenaltyChange}` +
      `&flightHotel-DriverAge=&flightHotel-SortBy=${this.state.sort}&flightHotel-IsDisney=0&flightHotel-MerchText=&flightHotel-dealMarker=&flightHotel-ChainName=&flightHotel-NumSenior=0`;

    if (preferredAirline !== 'N/A') {
      param = param + `&flightSearch-Airline=${preferredAirline}`;
    }

    let adultArrayString = '';

    if (formattedStarRatingString !== '') {
      param = param + `&${starString}&${formattedStarRatingString}`;
    }

    const adultsArray = this.state.numAdults;
    let totalAdults = 0;
    if (adultsArray !== [] && adultsArray!) {
      let key = '';
      for (let i = 1; i <= this.state.roomCount; i++) {
        key = `adultCount${i}`;
        if (this.state.childCount <= 0) {
          if (i === 1) {
            adultArrayString =
              adultArrayString + `&flightHotel-NumAdult${i}=${adultsArray[key]}&flightHotel-NumChild${i}=0`;
            totalAdults = Number(totalAdults) + Number(adultsArray[key]);
          } else {
            adultArrayString =
              adultArrayString + `&flightHotel-NumAdult${i}=${adultsArray[key]}&flightHotel-NumChild${i}=0`;
            totalAdults = Number(totalAdults) + Number(adultsArray[key]);
          }
        } else {
          if (i === 1) {
            adultArrayString = adultArrayString + `&flightHotel-NumAdult${i}=${adultsArray[key]}`;
            totalAdults = Number(totalAdults) + Number(adultsArray[key]);
          } else {
            adultArrayString = adultArrayString + `&flightHotel-NumAdult${i}=${adultsArray[key]}`;
            totalAdults = Number(totalAdults) + Number(adultsArray[key]);
          }
        }
      }
    }

    param = param + `&flightHotel-NumAdult=${totalAdults}`;

    param = param + `&flightHotel-NumChild=0`;

    let totalInfants = 0;
    const infantArray = this.state.numInfants;
    if (infantArray) {
      let key = '';
      for (let i = 1; i <= this.state.roomCount; i++) {
        key = `infantCount${i}`;
        totalInfants = Number(totalInfants) + Number(infantArray[key]);
      }
    }

    param = param + `&flightHotel-InfantInSeat=${totalInfants}`;

    if (this.state.hotelId) {
      param = param + `&flightHotel-HotelID=${this.state.hotelId}`;
    }
    if (adultArrayString !== '') {
      param = param + `&flightHotel-NumRoom=${this.state.roomCount}${adultArrayString}`;
    }

    let child = '';
    let childCount = 0;
    if (this.state.childCount > 0) {
      let key = '';
      let key2 = '';
      for (let i = 1; i <= this.state.roomCount; i++) {
        key = `childCount${i}`;
        child = child + `&flightHotel-NumChild${i}=` + this.state.numChild[key];
      }
      for (let i = 1; i <= this.state.roomCount; i++) {
        childCount = this.state.numChild[`childCount${i}`];
        for (let j = 0; j < childCount; j++) {
          key2 = this.state[`childAge${i}`];
          child = child + `&flightHotel-Rm${i}child${j + 1}age=` + key2[j];
        }
      }
    }

    if (child !== '') {
      param = param + child;
    }

    if (this.props.link.language) {
      param =
        param +
        `&flightHotel-marketingParam=clickid&flightHotel-marketingParamVal=&flightHotel-passthroughParam=langid&flightHotel-passthroughParamVal=${this.props.link.language}`;
    } else {
      param =
        param +
        `&flightHotel-marketingParam=clickid&flightHotel-marketingParamVal=&flightHotel-passthroughParam=langid&flightHotel-passthroughParamVal=1033`;
    }

    if (this.props.link.channel === 'Commission Junction') {
      if (this.props.link.pid || this.props.link.sid) {
        param = param + `&flightHotel-trackingParam=${this.props.link.channel}`;
      }
      if (this.props.link.pid && this.props.link.pid) {
        param = param + `&flightHotel-pid=${this.props.link.pid}`;
      }
      if (this.props.link.sid && this.props.link.sid) {
        param = param + `&flightHotel-sid=${this.props.link.sid}`;
      }
    }

    if (this.props.link.channel === 'PHG') {
      if (this.props.link.camRef || this.props.link.adRef || this.props.link.creativeRef || this.props.link.pubRef) {
        param = param + `&flightHotel-trackingParam=${this.props.link.channel}`;
      }
      if (this.props.link.camRef && this.props.link.camRef) {
        param = param + `&flightHotel-camref=${this.props.link.camRef}`;
      }
      if (this.props.link.adRef && this.props.link.adRef) {
        param = param + `&flightHotel-adref=${this.props.link.adRef}`;
      }
      if (this.props.link.creativeRef && this.props.link.creativeRef) {
        param = param + `&flightHotel-creativeref=${this.props.link.creativeRef}`;
      }
      if (this.props.link.pubRef && this.props.link.pubRef) {
        param = param + `&flightHotel-pubref=${this.props.link.pubRef}`;
      }
    }

    let amenityFilterString = '';
    if (this.state.allAmenity) {
      amenityFilterString =
        `&flightHotel-AmenityFilter[]=27&flightHotel-AmenityFilter[]=7&flightHotel-AmenityFilter[]=19` +
        `&flightHotel-AmenityFilter[]=14&flightHotel-AmenityFilter[]=17` +
        `&flightHotel-AmenityFilter[]=66` +
        `&flightHotel-AmenityFilter[]=16` +
        `&flightHotel-AmenityFilter[]=2158`;
    } else {
      const amenities = [
        this.state.air_condition,
        this.state.pool,
        this.state.speed,
        this.state.parking,
        this.state.pets,
        this.state.free_transport,
        this.state.breakfast,
        this.state.kitchen,
      ];
      const amenityNumber = [27, 7, 19, 14, 17, 66, 16, 2158];
      const amenityIndex = [];
      for (let i = 0; i < amenities.length; i++) {
        if (amenities[i]) {
          amenityIndex.push(i);
        }
      }
      if (amenityIndex.length > 0) {
        amenityFilterString = `&flightHotel-AmenityFilter[]=${amenityNumber[amenityIndex[0]]}`;
      }
      if (amenityIndex.length > 1) {
        for (let i = 1; i < amenityIndex.length; i++) {
          amenityFilterString = amenityFilterString + `&flightHotel-AmenityFilter[]=${amenityNumber[amenityIndex[i]]}`;
        }
      }
    }
    if (amenityFilterString !== '') {
      param = param + `${amenityFilterString}`;
    }

    const url = `/api/paandi/marketing-tools/geturl?${param}`;

    return fetch(url, {
      method: 'GET',
    })
      .then((res) =>
        res.text().then((response) => {
          return response;
        }),
      )
      .catch((err) => ({
        error: err,
      }));
  }

  public handleClick() {
    let isError = false;
    const errors1 = this.state.errors;
    if (
      this.state.selectedSourceLocation === '' ||
      this.state.selectedDestinationLocation === '' ||
      this.state.selectedSourceLocation === undefined ||
      this.state.selectedDestinationLocation === undefined
    ) {
      isError = true;
      errors1['location'] = 'Please enter Source and Destination';
    }
    if (
      this.state.startDate === undefined ||
      this.state.endDate === undefined ||
      this.state.startDate === '' ||
      (this.state.triptype === 'roundtrip' && this.state.endDate.length === 0)
    ) {
      isError = true;
      errors1['dates'] = 'Please enter your dates';
    }
    if (
      !!this.state.startDate &&
      !!this.state.endDate &&
      this.state.triptype === 'roundtrip' &&
      !hasValidDateRange(this.state.startDate, this.state.endDate)
    ) {
      isError = true;
      errors1['dates'] = 'Please enter valid dates';
    }
    let adultCount = 0;
    let key = '';
    const adultsArray = this.state.numAdults;
    for (let i = 1; i <= this.state.roomCount; i++) {
      key = `adultCount${i}`;
      adultCount = Number(adultCount) + Number(adultsArray[key]);
    }
    let totalInfants = 0;
    const infantArray = this.state.numInfants;
    if (infantArray) {
      for (let i = 1; i <= this.state.roomCount; i++) {
        key = `infantCount${i}`;
        totalInfants = Number(totalInfants) + Number(infantArray[key]);
      }
    }
    const childCount = this.state.childCount;
    if (Number(childCount) + Number(adultCount) + Number(totalInfants) > 6) {
      isError = true;
      errors1['travelerCount'] = 'The number of travelers cannot exceed 6 adults, children or infants';
    } else {
      errors1['travelerCount'] = '';
    }
    this.setState({
      triptype: this.state.triptype,
      error: isError,
      errors: errors1,
      message: isError ? 'Form contains errors! Please correct it and proceed' : '',
    });
    if (!isError) {
      this.setState({
        isLoading: true,
      });
      this.fetchData().then((data) => {
        this.setState({
          link: data.toString(),
          isLoading: false,
          copyMessage: 'Successfully copied the deeplink to clipboard',
        });
      });
    } else {
      window.scrollTo(0, 0);
    }
  }

  public handleUrlOpen() {
    window.open(this.state.link);
  }

  public copyToClipBoard() {
    const textField = document.createElement('textarea');
    textField.innerText = this.state.link;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand('copy');
    textField.remove();
    this.setState({
      copyStatus: true,
    });
  }

  public onSourceLocationChange = (selection: TypeaheadSelection) => {
    const errors1 = this.state.errors;
    errors1['location'] = '';
    this.setState(
      {
        errors: errors1,
        message: '',
      },
      () => {
        //tslint:disable-next-line:no-console
        //console.log('error ', errors1);
      },
    );
    const { data, term } = selection as TypeaheadSourceSelectionProps;
    // tslint:disable-next-line:no-console
    this.setState({ selectedSourceLocation: term }, () => {
      // tslint:disable-next-line:no-console
      //console.log(this.state.selectedSourceLocation);
    });
  };

  public onDestinationLocationChange = (selection: TypeaheadSelection) => {
    const errors1 = this.state.errors;
    errors1['location'] = '';
    this.setState(
      {
        errors: errors1,
        message: '',
      },
      () => {
        //tslint:disable-next-line:no-console
        //console.log('error ', errors1);
      },
    );
    const { data, term } = selection as TypeaheadDestinationSelectionProps;
    // tslint:disable-next-line:no-console
    this.setState({ selectedDestinationLocation: term }, () => {
      // tslint:disable-next-line:no-console
      //console.log(this.state.selectedDestinationLocation);
    });
    this.setState({
      regionId: data.regionId,
    });
  };

  public onAirlineChange = (event) => {
    this.setState({ preferredairline: event.target.value });
  };

  public onFlightClassChange = (event) => {
    this.setState({ flightclasschange: event.target.value });
  };

  public onFlightDirects = (event) => {
    this.setState({ flightdirectchange: event.target.value });
  };

  public onFlightPenalty = (event) => {
    this.setState({ flightpenaltychange: event.target.value });
  };

  public onAdultCountChange = (event) => {
    const adultId = event.target.getAttribute('id');
    const { value } = event.target;
    const adultArray = this.state.numAdults;
    adultArray[adultId] = Number(value);
    this.setState({
      numAdults: adultArray,
    });
  };

  public onInfantCountChange = (event) => {
    const infantId = event.target.getAttribute('id');
    const { value } = event.target;
    const infantArray = this.state.numInfants;
    infantArray[infantId] = Number(value);
    this.setState({
      numInfants: infantArray,
    });
  };

  public onSeniorCountChange = (event) => {
    this.setState({ seniorCount: event.target.value });
  };

  public onRoomCountChange = (event) => {
    let { value } = event.target;
    let statusChange = false;
    if (value > 1) {
      statusChange = true;
    }
    this.setState({
      roomCount: value,
      roomStateChange: statusChange,
    });
    const rooms = [];
    for (let i = 1; i < value; i++) {
      rooms.push(
        <RoomComponent
          onAdultCountChange={this.onAdultCountChange}
          onChildCountChange={this.onChildCountChange}
          onInfantCountChange={this.onInfantCountChange}
          roomCount={i + 1}
          childComponent={this.state[`childComponent${i + 1}`]}
        />,
      );
    }

    for (let i = Number(value) + 1; i <= 6; i++) {
      this.setState({
        [`childComponent${i}`]: [],
      });
    }
    this.setState({
      roomComponents: rooms,
    });
    const adultArray = this.state.numAdults;
    if (adultArray[`adultCount${value}`] === 0) {
      adultArray[`adultCount${value}`] = 1;
    }

    const childAgeArray = [...this.state[`childAge${value}`]];
    if (childAgeArray === []) {
      for (let i = 0; i < 6; i++) {
        childAgeArray.push(0);
      }
    }
    // tslint:disable-next-line:no-eval
    value = Number(value) + 1;
    const childArray = this.state.numChild;
    for (let i = value; i <= 6; i++) {
      adultArray[`adultCount${i}`] = 1;
      childArray[`childCount${i}`] = 0;
      this.setState({
        [`childAge${i}`]: [-1, -1, -1, -1, -1, -1],
      });
    }
    this.setState({
      numAdults: adultArray,
      numChild: childArray,
    });
    const infantArray = this.state.numInfants;

    let key = '';
    for (let i = value; i <= 6; i++) {
      key = `infantCount${i}`;
      infantArray[key] = 0;
    }

    this.setState({
      numInfants: infantArray,
    });
  };

  public renderPreferredAirline() {
    const preferredairline = [
      { key: 'N/A', value: 'N/A' },
      { key: 'A3', value: 'Aegean Airlines' },
      { key: 'EI', value: 'Aer Lingus' },
      { key: 'AR', value: 'Aerolineas Argentinas' },
      { key: 'AM', value: 'Aeromexico' },
      { key: 'VV', value: 'Aerosvit Airlines' },
      { key: 'AC', value: 'Air Canada' },
      { key: 'CA', value: 'Air China' },
      { key: 'AF', value: 'Air France' },
      { key: 'AI', value: 'Air India' },
      { key: 'JM', value: 'Air Jamaica' },
      { key: 'KM', value: 'Air Malta' },
      { key: 'NZ', value: 'Air New Zealand' },
      { key: 'AP', value: 'Air One' },
      { key: 'FJ', value: 'Air Pacific' },
      { key: 'TN', value: 'Air Tahiti Nui' },
      { key: 'TS', value: 'Air Transat' },
      { key: 'FL', value: 'AirTran Airways' },
      { key: 'AS', value: 'Alaska Airlines' },
      { key: 'AZ', value: 'Alitalia' },
      { key: 'NH', value: 'All Nippon Airways' },
      { key: 'AA', value: 'American Airlines' },
      { key: 'OZ', value: 'Asiana Airlines' },
      { key: 'OS', value: 'Austrian Airlines' },
      { key: 'BD', value: 'bmi' },
      { key: 'BA', value: 'British Airways' },
      { key: 'SN', value: 'Brussels Airlines' },
      { key: 'BW', value: 'Caribbean Airlines' },
      { key: 'CX', value: 'Cathay Pacific' },
      { key: 'KX', value: 'Cayman Airways' },
      { key: 'CI', value: 'China Airlines' },
      { key: 'CZ', value: 'China Southern Airlines' },
      { key: 'CO', value: 'Continental' },
      { key: 'CM', value: 'Copa' },
      { key: 'OK', value: 'Czech Airlines' },
      { key: 'DL', value: 'Delta' },
      { key: 'MS', value: ' Egyptair' },
      { key: 'LY', value: 'El Al' },
      { key: 'EK', value: 'Emirates' },
      { key: 'ET', value: 'Ethiopian Airlines' },
      { key: 'EY', value: 'Etihad Airways' },
      { key: 'GJ', value: 'Eurofly' },
      { key: 'BR', value: 'EVA Airways' },
      { key: 'XE', value: 'ExpressJet Airlines' },
      { key: 'AY', value: 'Finnair' },
      { key: 'F9', value: 'Frontier Airlines' },
      { key: 'GF', value: 'Gulf Air' },
      { key: 'HU', value: 'Hainan Air' },
      { key: 'HA', value: 'Hawaiian Airlines' },
      { key: 'IB', value: 'Iberia' },
      { key: 'FI', value: 'Icelandair' },
      { key: 'JL', value: 'Japan Airlines' },
      { key: '9W', value: 'Jet Airways' },
      { key: 'b6', value: 'JetBlue Airways' },
      { key: 'KD', value: 'KD avia' },
      { key: 'IT', value: 'Kingfisher Airlines' },
      { key: 'KL', value: 'KLM' },
      { key: 'KE', value: 'Korean Air' },
      { key: 'LR', value: 'LACSA' },
      { key: 'LA', value: 'LAN Airlines' },
      { key: '4M', value: 'Lan Argentina' },
      { key: 'XL', value: 'LAN Ecuador' },
      { key: 'LP', value: 'LAN Peru' },
      { key: 'LO', value: 'LOT-Polish Airlines' },
      { key: 'LT', value: 'LTU' },
      { key: 'LH', value: 'Lufthansa' },
      { key: 'MH', value: 'Malaysia Airlines' },
      { key: 'MA', value: 'Malev Hungarian Airlines' },
      { key: 'MP', value: 'Martinair Holland' },
      { key: 'MH', value: 'Mexicana' },
      { key: 'NW', value: 'Northwest' },
      { key: 'OA', value: 'Olympic' },
      { key: 'PR', value: 'Philippine Airlines' },
      { key: 'QF', value: 'Qantas Airways' },
      { key: 'QR', value: 'Qatar Airways' },
      { key: 'SK', value: 'SAS' },
      { key: 'SA', value: 'South African Airways' },
      { key: 'JK', value: 'Spanair' },
      { key: 'LY', value: 'Sun Country Airlines' },
      { key: 'LX', value: 'Swiss International Air Lines' },
      { key: 'TA', value: 'TACA' },
      { key: 'JJ', value: 'TAM Brazilian Airlines' },
      { key: 'TP', value: ' TAP Portugal' },
      { key: 'TG', value: 'Thai Air International' },
      { key: 'TK', value: 'Turkish Airlines' },
      { key: 'UA', value: 'United' },
      { key: 'US', value: ' US Airways' },
      { key: 'VA', value: 'V Australia' },
      { key: 'VN', value: 'Vietnam Airlines' },
      { key: 'VX', value: 'Virgin America' },
      { key: 'VS', value: 'Virgin Atlantic' },
      { key: 'WS', value: 'West Jet' },
    ];

    return preferredairline.map((opts) => {
      return (
        <option key={opts.key} value={opts.key}>
          {opts.value}
        </option>
      );
    });
  }

  public renderAdultCountChange() {
    const adultCount = [
      { key: '1', value: '1 Adult' },
      { key: '2', value: '2 Adults' },
      { key: '3', value: '3 Adults' },
      { key: '4', value: '4 Adults' },
      { key: '5', value: '5 Adults' },
      { key: '6', value: '6 Adults' },
    ];

    return adultCount.map((opts) => {
      return (
        <option key={opts.key} value={opts.key}>
          {opts.value}
        </option>
      );
    });
  }

  public renderSeniorCountChange() {
    const seniorCount = [
      { key: '0', value: '0 Seniors' },
      { key: '1', value: '1 Seniors' },
      { key: '2', value: '2 Seniors' },
      { key: '3', value: '3 Seniors' },
      { key: '4', value: '4 Seniors' },
      { key: '5', value: '5 Seniors' },
      { key: '6', value: '6 Seniors' },
    ];

    return seniorCount.map((opts) => {
      return (
        <option key={opts.key} value={opts.key}>
          {opts.value}
        </option>
      );
    });
  }

  public renderNumChild() {
    const numChild = [
      { key: '0', value: '0 Childs' },
      { key: '1', value: '1 Child' },
      { key: '2', value: '2 Childs' },
      { key: '3', value: '3 Childs' },
      { key: '4', value: '4 Childs' },
      { key: '5', value: '5 Childs' },
      { key: '6', value: '6 Childs' },
    ];

    return numChild.map((opts) => {
      return (
        <option key={opts.key} value={opts.key}>
          {opts.value}
        </option>
      );
    });
  }

  public renderInfants() {
    const infantArray = [0, 1, 2, 3, 4, 5, 6];
    let opt;

    return infantArray.map((infant) => {
      if (infant > 1 || infant < 1) {
        opt = (
          <option key={infant} value={infant}>
            {infant} Infants
          </option>
        );
      } else {
        opt = (
          <option key={infant} value={infant}>
            {infant} Infant
          </option>
        );
      }

      return opt;
    });
  }

  public renderInfantCountChange() {
    const infantCount = [
      { key: '0', value: '0 Infants in Seats' },
      { key: '1', value: '1 Infants in Seats' },
    ];

    return infantCount.map((opts) => {
      return (
        <option key={opts.key} value={opts.key}>
          {opts.value}
        </option>
      );
    });
  }

  public renderFlightClassChange() {
    const flightclasschange = [
      { key: 'e', value: 'Economy/Coach' },
      { key: 'b', value: 'Business' },
      { key: 'f', value: 'First Class' },
    ];

    return flightclasschange.map((opts) => {
      return (
        <option key={opts.key} value={opts.key}>
          {opts.value}
        </option>
      );
    });
  }

  public renderFlightDirects() {
    const flightdirectchange = [
      { key: '0', value: 'all flights' },
      { key: '1', value: 'non stop only' },
    ];

    return flightdirectchange.map((opts) => {
      return (
        <option key={opts.key} value={opts.key}>
          {opts.value}
        </option>
      );
    });
  }

  public renderRoomCount = () => {
    const rooms = [1, 2, 3, 4, 5, 6];
    let opt;

    return rooms.map((room) => {
      if (room > 1) {
        opt = (
          <option key={room} value={room}>
            {room} Rooms
          </option>
        );
      } else {
        opt = (
          <option key={room} value={room}>
            {room} Room
          </option>
        );
      }

      return opt;
    });
  };

  public renderFlightPenalty() {
    const flightpenaltychange = [
      { key: '0', value: 'all flights' },
      { key: '1', value: 'avoid changing penalties' },
    ];

    return flightpenaltychange.map((opts) => {
      return (
        <option key={opts.key} value={opts.key}>
          {opts.value}
        </option>
      );
    });
  }

  public render() {
    const roomComponent = (
      <RoomComponent
        onAdultCountChange={this.onAdultCountChange}
        onChildCountChange={this.onChildCountChange}
        onInfantCountChange={this.onInfantCountChange}
        roomCount="1"
        childComponent={this.state[`childComponent1`]}
      />
    );

    return (
      <>
        <UitkToast onCloseRef={this.onCloseRef} show={this.state.copyStatus} verticalOffset={200}>
          Successfully copied the deeplink to clipboard
        </UitkToast>

        <UitkSpacing padding={{ blockstart: 'three', blockend: 'three' }}>
          <UitkHeading tag="h2" size={5}>
            Select your Origin/Destination
          </UitkHeading>
        </UitkSpacing>

        <UitkLayoutGrid columns={2} space="three">
          <UitkLayoutGridItem>
            <div>
              <UitkTypeahead
                adapter={
                  new ESSAdapter({
                    client: 'Homepage',
                    dest: true,
                    domain: 'https://www.expedia.com/',
                    expuserid: -1,
                    features: 'contextual_ta|postal_code|multiregion_parent|ta_hierarchy',
                    guid: '8cbe8b8bee5249e08c293ae5ec40abea', // you can switch this with your own guid but only works if user has serach history
                    lob: 'FLIGHTS',
                    locale: 'en_US',
                    maxResults: 10,
                    personalize: false, // change to true to see recent searches
                    regionType: 2047,
                    siteId: 1,
                  })
                }
                label="Flying From"
                name="flightSourceLocation"
                icon="place"
                onUpdate={this.onSourceLocationChange}
              />
              <span style={{ color: 'red' }}>{this.state.errors['location']}</span>
            </div>
          </UitkLayoutGridItem>

          <UitkLayoutGridItem>
            <div>
              <UitkTypeahead
                adapter={
                  new ESSAdapter({
                    client: 'Homepage',
                    dest: true,
                    domain: 'https://www.expedia.com/',
                    expuserid: -1,
                    features: 'contextual_ta|postal_code|multiregion_parent|ta_hierarchy',
                    guid: '8cbe8b8bee5249e08c293ae5ec40abea', // you can switch this with your own guid but only works if user has serach history
                    lob: 'FLIGHTS',
                    locale: 'en_US',
                    maxResults: 10,
                    personalize: false, // change to true to see recent searches
                    regionType: 2047,
                    siteId: 1,
                  })
                }
                label="Flying To"
                name="flightDestinationLocation"
                icon="place"
                onUpdate={this.onDestinationLocationChange}
              />
            </div>
          </UitkLayoutGridItem>
        </UitkLayoutGrid>
        <div>
          <UitkSpacing padding={{ blockstart: 'three', blockend: 'three' }}>
            <UitkHeading tag="h2" size={5}>
              Select your Dates
            </UitkHeading>
          </UitkSpacing>
          <UitkLayoutFlex space="two">
            <>
              <UitkLayoutFlexItem minWidth="half_width">
                <div>
                  <UitkTextInput
                    id="startDate"
                    label="From Date"
                    placeholder="mm/dd/yyyy"
                    name="startDate"
                    value={this.state.startDate}
                    onChange={this.handleDatesChange}
                    invalid={this.validateDates('startDate')}
                    icon="today"
                  />
                </div>
              </UitkLayoutFlexItem>
              <UitkLayoutFlexItem minWidth="half_width">
                <div>
                  <UitkTextInput
                    id="endDate"
                    label="To Date"
                    placeholder="mm/dd/yyyy"
                    name="endDate"
                    value={this.state.endDate}
                    onChange={this.handleDatesChange}
                    invalid={this.validateDates('endDate')}
                    icon="today"
                  />
                </div>
              </UitkLayoutFlexItem>
            </>
          </UitkLayoutFlex>
        </div>
        <span style={{ color: 'red' }}>{this.state.errors['dates']}</span>

        <UitkSpacingHr />

        <UitkSpacing padding={{ blockstart: 'three', blockend: 'three' }}>
          <UitkHeading tag="h2" size={5}>
            Who is Travelling ?
          </UitkHeading>
        </UitkSpacing>

        <Viewport>
          <ViewLarge>
            <>
              <UitkLayoutGrid columns={2} space="three">
                <UitkLayoutGridItem>
                  <UitkSelect
                    id="room-count"
                    label=""
                    icon="room"
                    onChange={this.onRoomCountChange}
                    hasVisibleLabel={false}
                  >
                    {this.renderRoomCount()}
                  </UitkSelect>
                </UitkLayoutGridItem>
              </UitkLayoutGrid>
              {roomComponent}
              {this.state.roomStateChange ? this.state.roomComponents : ''}

              <span style={{ color: 'red' }}>{this.state.errors['travelerCount']}</span>
            </>
          </ViewLarge>

          <ViewSmall>
            <>
              <UitkSelect
                id="room-count"
                label=""
                icon="room"
                onChange={this.onRoomCountChange}
                hasVisibleLabel={false}
              >
                {this.renderRoomCount()}
              </UitkSelect>

              {roomComponent}
              {this.state.roomStateChange ? this.state.roomComponents : ''}

              <span style={{ color: 'red' }}>{this.state.errors['travelerCount']}</span>
            </>
          </ViewSmall>
        </Viewport>

        <UitkSpacingHr />

        <UitkHeading tag="h2" size={5}>
          Are there any more Flight Details?
        </UitkHeading>

        <UitkSelect onChange={this.onAirlineChange} id="preferredairline" label="Preferred Airline">
          {this.renderPreferredAirline()}
        </UitkSelect>

        <Viewport>
          <ViewLarge>
            <UitkSpacing padding={{ blockstart: 'three', blockend: 'six' }}>
              <UitkLayoutGrid columns={4} space="three">
                <>
                  <UitkLayoutGridItem>
                    <div>
                      <UitkSelect
                        icon="lob_flights"
                        onChange={this.onFlightClassChange}
                        id="flightclasschange"
                        label="Class"
                      >
                        {this.renderFlightClassChange()}
                      </UitkSelect>
                    </div>
                  </UitkLayoutGridItem>

                  <UitkLayoutGridItem>
                    <UitkSelect
                      icon="lob_flights"
                      onChange={this.onFlightDirects}
                      id="flightdirectchange"
                      label="Direct"
                    >
                      {this.renderFlightDirects()}
                    </UitkSelect>
                  </UitkLayoutGridItem>

                  <UitkLayoutGridItem>
                    <UitkSelect
                      icon="lob_flights"
                      onChange={this.onFlightPenalty}
                      id="flightpenaltychange"
                      label="No Change Penalty"
                    >
                      {this.renderFlightPenalty()}
                    </UitkSelect>
                  </UitkLayoutGridItem>
                </>
              </UitkLayoutGrid>
            </UitkSpacing>
          </ViewLarge>
          <ViewSmall>
            <UitkSpacing padding={{ blockstart: 'three' }}>
              <>
                <UitkSpacing padding={{ blockstart: 'three', blockend: 'three' }}>
                  <div>
                    <UitkSelect
                      icon="lob_flights"
                      onChange={this.onFlightClassChange}
                      id="flightclasschange"
                      label="Class"
                    >
                      {this.renderFlightClassChange()}
                    </UitkSelect>
                  </div>
                </UitkSpacing>

                <UitkSpacing padding={{ blockstart: 'three', blockend: 'three' }}>
                  <div>
                    <UitkSelect
                      icon="lob_flights"
                      onChange={this.onFlightDirects}
                      id="flightdirectchange"
                      label="Direct"
                    >
                      {this.renderFlightDirects()}
                    </UitkSelect>
                  </div>
                </UitkSpacing>

                <UitkSpacing padding={{ blockstart: 'three', blockend: 'three' }}>
                  <div>
                    <UitkSelect
                      icon="lob_flights"
                      onChange={this.onFlightPenalty}
                      id="flightpenaltychange"
                      label="No Change Penalty"
                    >
                      {this.renderFlightPenalty()}
                    </UitkSelect>
                  </div>
                </UitkSpacing>
              </>
            </UitkSpacing>
          </ViewSmall>
        </Viewport>

        <UitkSpacingHr />

        <UitkSpacing margin={{ block: 'three' }}>
          <UitkHeading tag="h2" size={5}>
            Are There Any More Hotel Details?
          </UitkHeading>
        </UitkSpacing>
        <UitkLayoutGrid columns={2}>
          <>
            <UitkLayoutGridItem>
              <div>
                <UitkHeading tag="h2" size={5}>
                  Star Rating
                </UitkHeading>
                {this.renderStarRating()}
              </div>
            </UitkLayoutGridItem>

            <UitkLayoutGridItem>
              <div>
                <UitkHeading tag="h2" size={5}>
                  Amenities*
                </UitkHeading>

                <UitkToggleSwitch
                  id="all_amenity"
                  checked={this.state.allAmenity}
                  onChange={this.handleAmenity}
                  label="All amenities"
                />

                <UitkLayoutFlex wrap="wrap" className="deeplink-builder__all-amenities" space="two">
                  <>{this.renderAmenities()} </>
                </UitkLayoutFlex>
                <p>*Some destinations do not support all Amenity types, please test your deeplink before using.</p>
              </div>
            </UitkLayoutGridItem>
          </>
        </UitkLayoutGrid>

        <UitkSpacing margin={{ block: 'three' }}>
          <UitkLayoutGrid columns={2}>
            <>
              <UitkLayoutGridItem>
                <UitkToggleSwitch
                  id="pin_a_hotel"
                  checked={this.state.pinHotel}
                  onChange={this.handlePin}
                  label="Pin a Hotel to Top of Search Results?"
                />
              </UitkLayoutGridItem>

              {this.state.pinHotel ? (
                <UitkLayoutGridItem>
                  <UitkTypeahead
                    adapter={
                      new ESSAdapter({
                        client: 'lodging',
                        dest: true,
                        domain: 'https://www.expedia.com/',
                        expuserid: -1,
                        features: 'contextual_ta|postal_code|multiregion_parent|ta_hierarchy',
                        guid: '8cbe8b8bee5249e08c293ae5ec40abea', // you can switch this with your own guid but only works if user has serach history
                        lob: 'HOTELS',
                        locale: 'en_US',
                        maxResults: 10,
                        personalize: false, // change to true to see recent searches
                        regionId: this.state.regionId,
                        regionType: 128,
                        siteId: 1,
                      })
                    }
                    label="Select the Hotel"
                    name="hotelLocation"
                    icon="lob_hotels"
                    onUpdate={this.handleHotelId}
                  />
                  <span style={{ color: 'red' }}>{this.state.errors['hotelId']}</span>
                </UitkLayoutGridItem>
              ) : (
                ''
              )}
            </>
          </UitkLayoutGrid>
        </UitkSpacing>

        <UitkLayoutGrid columns={2} alignItems="center">
          <>
            <UitkLayoutGridItem>
              <UitkHeading tag="h2" size={5}>
                Default Sort
              </UitkHeading>
            </UitkLayoutGridItem>
            <UitkLayoutGridItem>
              <UitkSelect
                icon="menu"
                id="selectsampleicon"
                hasVisibleLabel={false}
                label=""
                onChange={this.handleSortChange}
              >
                {this.renderSort()}
              </UitkSelect>
            </UitkLayoutGridItem>
          </>
        </UitkLayoutGrid>

        <UitkSpacing margin={{ block: 'three' }}>
          <UitkPrimaryButton name="buildlink" type="button" onClick={this.handleClick} isFullWidth={true}>
            Build Deeplink
          </UitkPrimaryButton>
        </UitkSpacing>

        <div>
          <UitkText align="left" size={500} weight="bold">
            Here is your Deeplink
          </UitkText>
          {this.state.isLoading ? (
            <Loader />
          ) : (
            <UitkTextArea id="deeplink_holder" label="" name="deeplink_holder" value={this.state.link} />
          )}
        </div>

        <UitkSpacing margin={{ block: 'three' }}>
          <div>
            <UitkLayoutFlex space="three">
              <>
                <UitkPrimaryButton name="buildlink" type="button" onClick={this.copyToClipBoard}>
                  Copy Link
                </UitkPrimaryButton>

                <UitkPrimaryButton name="buildlink" type="button" onClick={this.handleUrlOpen}>
                  Test Link
                </UitkPrimaryButton>
              </>
            </UitkLayoutFlex>
          </div>
        </UitkSpacing>
      </>
    );
  }
  public componentWillUnMount() {
    setTimeout(() => this.setState({ message: '' }), 3000);
  }
  public componentDidUpdate() {
    setTimeout(() => this.setState({ copyStatus: false }), 4000);
  }
}
